import { sanitizeCssValue as sc } from "./btnHoverCss";

export type DeviceVar = { name: string; base: string; tablet: string; mobile: string };

export const deviceVarCss = (scopeSelector: string, vars: DeviceVar[]): string => {
  if (vars.length === 0) return "";
  const line = (v: DeviceVar, val: string) => `--${v.name}:${sc(val)};`;
  const base = vars.map((v) => line(v, v.base)).join("");
  const tablet = vars.filter((v) => v.tablet).map((v) => line(v, v.tablet)).join("");
  const mobile = vars.filter((v) => v.mobile).map((v) => line(v, v.mobile)).join("");
  return `${scopeSelector}{${base}}`
    + (tablet ? `@media(max-width:768px){${scopeSelector}{${tablet}}}` : "")
    + (mobile ? `@media(max-width:480px){${scopeSelector}{${mobile}}}` : "");
};
